import { TextInput } from '../fields'
import FileDropField from '../FileDropField'

/** `showDocs=false` renders the profile-edit variant — the JSON update
    contract carries no files, so document uploads are registration-only. */
export default function StepKyc({ showDocs = true }) {
  return (
    <div className="step-panel space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextInput
          name="aadhar_number"
          label="Aadhar Number"
          placeholder="XXXX XXXX XXXX"
          maxLength={12}
          digitsOnly
          rules={{
            required: 'Aadhar number is required.',
            pattern: { value: /^[0-9]{12}$/, message: 'Enter the 12-digit Aadhar number without spaces.' },
          }}
        />
        <TextInput
          name="pan_number"
          label="PAN Number"
          placeholder="ABCDE1234F"
          maxLength={10}
          style={{ textTransform: 'uppercase' }}
          rules={{
            required: 'PAN number is required.',
            pattern: { value: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, message: 'Enter a valid PAN, e.g. ABCDE1234F.' },
          }}
        />
      </div>
      {showDocs && (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FileDropField
          name="aadhar_doc"
          label="Aadhar Document"
          hint="(max 2MB)"
          accept=".pdf,.jpg,.jpeg,.png"
          maxSizeMb={2}
          requiredMessage="Upload your Aadhar document."
          icon="🪪"
          prompt="Upload Aadhar"
        />
        <FileDropField
          name="pan_doc"
          label="PAN Document"
          hint="(max 1MB)"
          accept=".pdf,.jpg,.jpeg,.png"
          maxSizeMb={1}
          requiredMessage="Upload your PAN document."
          icon="🪪"
          prompt="Upload PAN"
        />
      </div>
      )}
    </div>
  )
}
